export const PORTFOLIO_FILTER_CATEGORIES = [
  { id: 'all',         label: 'All Work' },
  { id: 'wedding',     label: 'Weddings' },
  { id: 'pre-wedding', label: 'Pre-Wedding' },
  { id: 'engagement',  label: 'Engagements' },
  { id: 'event',       label: 'Events' },
  { id: 'portrait',    label: 'Portraits' },
];

export const PORTFOLIOS = [
  {
    slug: 'sunil-thriveni',
    names: 'Sunil & Thriveni',
    type: 'Wedding',
    category: 'wedding',
    date: 'December 24, 2025',
    location: 'Visakhapatnam',
    cover: '/images/Slide-1.png',
    photoCount: 400,
  },
  {
    slug: 'arjun-meghana',
    names: 'Arjun & Meghana',
    type: 'Pre-Wedding',
    category: 'pre-wedding',
    date: 'November 8, 2025',
    location: 'Hyderabad',
    cover: 'https://picsum.photos/seed/rz-pw1/800/1050',
    photoCount: 135,
  },
  {
    slug: 'karthik-sravani',
    names: 'Karthik & Sravani',
    type: 'Wedding',
    category: 'wedding',
    date: 'October 18, 2025',
    location: 'Vizag Beach',
    cover: 'https://picsum.photos/seed/rz-wd2/800/1050',
    photoCount: 520,
  },
  {
    slug: 'rahul-ananya',
    names: 'Rahul & Ananya',
    type: 'Engagement',
    category: 'engagement',
    date: 'September 5, 2025',
    location: 'Visakhapatnam',
    cover: 'https://picsum.photos/seed/rz-en1/800/1050',
    photoCount: 98,
  },
  {
    slug: 'venkat-deepika',
    names: 'Venkat & Deepika',
    type: 'Wedding',
    category: 'wedding',
    date: 'August 14, 2025',
    location: 'Rajahmundry',
    cover: 'https://picsum.photos/seed/rz-wd3/800/1050',
    photoCount: 480,
  },
  {
    slug: 'sri-krishna-wedding',
    names: 'Sri Krishna Kalyanam',
    type: 'Event',
    category: 'event',
    date: 'July 21, 2025',
    location: 'Visakhapatnam',
    cover: 'https://picsum.photos/seed/rz-ev1/800/1050',
    photoCount: 310,
  },
  {
    slug: 'mohan-lavanya',
    names: 'Mohan & Lavanya',
    type: 'Pre-Wedding',
    category: 'pre-wedding',
    date: 'June 15, 2025',
    location: 'Araku Valley',
    cover: 'https://picsum.photos/seed/rz-pw2/800/1050',
    photoCount: 160,
  },
  {
    slug: 'aditya-portraits',
    names: 'Aditya Sharma',
    type: 'Portrait',
    category: 'portrait',
    date: 'May 30, 2025',
    location: 'Studio, Vizag',
    cover: 'https://picsum.photos/seed/rz-pt1/800/1050',
    photoCount: 72,
  },
  {
    slug: 'ravi-keerthi',
    names: 'Ravi & Keerthi',
    type: 'Engagement',
    category: 'engagement',
    date: 'April 12, 2025',
    location: 'Visakhapatnam',
    cover: 'https://picsum.photos/seed/rz-en2/800/1050',
    photoCount: 110,
  },
];
